import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const LaborEarlyBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-pink-500 font-semibold text-white">
      {t('component:badge.earlyPhase')}
    </Badge>
  );
};
